module.exports = __webpack_public_path__ + "media/student_finance/personal-finance-eb2e6a1e.png";